import { Configuration } from '@shared/models/configuration';

// @dynamic
export class StreamsConfig {
  private static get FootprintApi (): string {
    return Configuration.FootprintApi;
  }

  static get StreamsApi (): string {
    return `${StreamsConfig.FootprintApi}StreamSettings?projectId=[PROJECT_ID]`;
  }

  static get AddStreamsApi (): string {
    return `${StreamsConfig.FootprintApi}StreamSettings`;
  }

  static get DeleteStreamsApi (): string {
    return `${StreamsConfig.FootprintApi}StreamSettings/Delete`;
  }
}
